<template>
  <div>
    <b-modal v-model="modal.ver" size="xl" title="Crear Ubicaciones" hide-footer centered>
      <el-steps class="mb-4" align-center :active="modal.paso" finish-status="success" process-status="process">
          <el-step title="Paso 1" description="Crear Ubicacion"></el-step>
          <el-step title="Paso 2" description="Asignar Ubicacion"></el-step>
      </el-steps>
      <crear v-if="modal.paso == 0 "></crear>
      <enlazar :asociar="asociar" v-if="modal.paso == 1"></enlazar>
    </b-modal>
  </div>
</template>

<script>
  import {mapState} from "vuex"
  import crear from './crear.vue';
  import enlazar from './enlazar.vue';

  export default {
    name: "modal",
    components: {
        crear,
        enlazar
    },
    computed: {
      ...mapState('ubicacion', ['modal', 'asociar'])
    }
  }
</script>
